import { Listeners } from '../../utils/listeners';
import { blessState } from './bless_state';
import { Context } from './context';
import { bindInstanceMethods } from './instance_methods';
import { defineTargetEls } from './target_properties';
export class Module {
  static build(el, application) {
    const context = new Context(el, application);
    const module = new this(el, context);
    defineTargetEls(this);
    bindInstanceMethods(this, module);
    blessState(this, module);
    module.initialize();
    module.setupListeners();
    module.ready();
    return module;
  }

  constructor(el, context) {
    this.el = el;
    this.context = context;
    this.listeners = new Listeners();
  }

  get element() {
    return this.context.element;
  }

  get identifier() {
    return this.context.identifier;
  }

  get className() {
    return this.context.className;
  }

  get data() {
    return this.context.data;
  }

  get state() {
    return this.context.state;
  }

  get targets() {
    return this.context.targets;
  }

  initialize() {}

  setupListeners() {}

  ready() {}

}